var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCollecteTriValorisation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_2",
    "data-name": "Calque 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 129.78 80.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .collect-tri-cls-1 {\n        stroke: #030f40;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 5px;\n      }\n\n      .collect-tri-cls-1, .collect-tri-cls-2 {\n        fill: none;\n      }\n\n      .collect-tri-cls-3 {\n        clip-path: url(#clippath-11);\n      }\n\n      .collect-tri-cls-4 {\n        clip-path: url(#clippath-2);\n      }\n\n      .collect-tri-cls-5 {\n        clip-path: url(#clippath-13);\n      }\n\n      .collect-tri-cls-6 {\n        clip-path: url(#clippath-6);\n      }\n\n      .collect-tri-cls-2 {\n        stroke-width: 0px;\n      }\n\n      .collect-tri-cls-7 {\n        clip-path: url(#clippath-7);\n      }\n\n      .collect-tri-cls-8 {\n        clip-path: url(#clippath-1);\n      }\n\n      .collect-tri-cls-9 {\n        clip-path: url(#clippath-4);\n      }\n\n      .collect-tri-cls-10 {\n        clip-path: url(#clippath-12);\n      }\n\n      .collect-tri-cls-11 {\n        clip-path: url(#clippath-9);\n      }\n\n      .collect-tri-cls-12 {\n        clip-path: url(#clippath);\n      }\n\n      .collect-tri-cls-13 {\n        clip-path: url(#clippath-3);\n      }\n\n      .collect-tri-cls-14 {\n        clip-path: url(#clippath-8);\n      }\n\n      .collect-tri-cls-15 {\n        clip-path: url(#clippath-5);\n      }\n\n      .collect-tri-cls-16 {\n        clip-path: url(#clippath-10);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M89.48,53.87v.33c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.33h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M71.93,51.28h.33c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-.33v-5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M87.31,24.16h-.33c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h.33v5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M116.97,69.17h-.33c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h.33v5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M98.89,64.17h.98c1.38,0,2.5,1.12,2.5,2.5s-1.12,2.5-2.5,2.5h-.98v-5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M77.53,69.17h-.98c-1.38,0-2.5-1.12-2.5-2.5s1.12-2.5,2.5-2.5h.98v5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M74.76,44.61v.98c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.98h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M69.76,10.98v-.98c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v.98h-5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M59.41,44.61v.98c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.98h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M54.41,10.98v-.98c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v.98h-5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M44.07,44.61v.98c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.98h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M39.07,10.98v-.98c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v.98h-5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M28.73,44.61v.98c0,1.38-1.12,2.5-2.5,2.5s-2.5-1.12-2.5-2.5v-.98h5Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "collect-tri-cls-2",
    d: "M23.73,10.98v-.98c0-1.38,1.12-2.5,2.5-2.5s2.5,1.12,2.5,2.5v.98h-5Z"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image",
    width: 6,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAHElEQVQYlWNk5nf4z4AFMGETHBESLAwMDFiDBACqdwJqC1MbLQAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-2",
    width: 12,
    height: 6,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAACXBIWXMAAAsSAAALEgHS3X78AAAAFklEQVQYlWNk5nf4z0ACYCJF8XDRAACGQgFdx9DzSwAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("image", {
    id: "image-3",
    width: 6,
    height: 12,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAFUlEQVQYlWNk5ndgYoAAZoZRgA8AAGc/AFkUf5KGAAAAAElFTkSuQmCC"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pictos"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-12"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(83.51 52.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAIElEQVQYlWNk5ndgZ2Bg+M/AwMDIgA6Y+R3Y8PFHFgAAQJ8CCy8HNYAAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 90,
    height: 59,
    transform: "translate(-.49 10.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAAA7CAYAAAD7AJ39AAAACXBIWXMAAAsSAAALEgHS3X78AAACaklEQVR4nO2b0VajMBRFDwXrzLzwS3x63/yd6dKl1jbUh86l1xhCEi6M2rPX0pAU2uXm9pCGWqGQuu360mMTOWf0zxP76PY80pefPtLvVV+2ndoOPQ4A2MT/1jArSLbAl55KtcRrF4n+JkwJGzsRoXdKzvMG98kWvVI1l1ajJbETEYoeHRufjm1yXvk/R0aF6ROQuo9QWrGx42VcZ3SVJfoHETsZ8ljl9WP7a7H6Yjjsk3z2pqrZ7Xc/Oe+TqdvuAR/fFRsgMTooOYszLqLFWQ9gMymIkos44jK/FvpbzeglcaqV7ToqmtVcxCk0NiqakouRWYoIb4ZfuVBylIPXdwDqoLBvspbxldH5DADuU0UzMmYjgk9Q8ZEVHZScxFto7INoRoYJ4jB8MWRkmCGCj6q9S4oOSs7iGBprAEaGMbqi72SwYWSYc/RaABMfWCi5CC16qGouKtnjV3T8YshqLmZ6Hk1M8Kd3jI6FePX6DlPr0aSIHtf42MoYRdvzptpBeAObr0CRK350AMArK9qeEy6L//d6kKLtkTssj7hmNEUvgOTyAaqyKdqeQ6C9p2h7nkNjFG2PfDJ8+df+BhgdS/DX6zM6FqKHV80AXijaHpH8jGte/6Foe55CYxRtj8yj9UfxX7NF1233Ff6xZ1HcfpezHmRf0bcguQC52T18NxqYMb2j5FH8W1nlC/+UPI7b7w51223dfjcIr9tuyxuwC6AlS5+iVyI7OmKxkXl1vilY0SuRJZrVXA4reiVMRLOap0kWzbnzPBgdK1HNrVTGRhqs6JWYJZrVnA4reiWKRbOa86iA/KkbJefzDrHcAnxCTEN9AAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-8"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(70.51 50.41)",
    xlinkHref: "#image-2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-4"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(76.51 18.41)",
    xlinkHref: "#image-2"
  })), /*#__PURE__*/React.createElement("image", {
    width: 44,
    height: 51,
    transform: "translate(86.51 18.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACwAAAAzCAYAAADsBOpPAAAACXBIWXMAAAsSAAALEgHS3X78AAAAzklEQVRoge3Y0Q3CMAxF0VsYgJUYvSt1gAp++QCaNu85juQ7gHVkKZGS5f54vjC1b+uinnlTD/zMsQwrGPRoOxi06BAw6NBhYNCg5ae4BdVze8jB4EVbwOBD28DgQVvBoEfbwaBFh4BBhw4DgwYdCoZ+dDgY+tBDwHAdPQwM19BDwXAePRwM59ApwNCOTgOGNnQqMByj04HhPzolGH6jQ990igrsrsDuCuyuwO4K7K7A7grsrsDuCuxuOnDqz8BvTbfhArubCrxv6zIVGOAN0Y5QKxjgIgIAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-13"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(106.51 63.41)",
    xlinkHref: "#image-2"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-9"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 6,
    transform: "translate(98.51 63.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAACXBIWXMAAAsSAAALEgHS3X78AAAALklEQVQYlWNk5nf4wsDAwM1AJGBiYGBgZGBg+E+KBnZiFcM0/CNVw39SnUSSDQDqSAZeXyAD5AAAAABJRU5ErkJggg=="
  })), /*#__PURE__*/React.createElement("image", {
    width: 24,
    height: 6,
    transform: "translate(76.51 63.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAGCAYAAADZq14TAAAACXBIWXMAAAsSAAALEgHS3X78AAAAjklEQVQokXWQSw6DMAxEXxIon7aw6IW4/4WKhEi6qGkHi1iyMs+OM5EDQJqXEXgBg+UDeNp5txxFKw+mj9nJZjtgimleAt/YgWx6M9Z6qXB2HPlHieYEkKTZGms9VDg6Pj75a2ohcY7V3fWzV9xJrXiDTfQO9BUzgHflY/pGjpx3p2tp3JDn1vTNGatZ8wEkEB27I7FZlAAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-15"
  }, /*#__PURE__*/React.createElement("image", {
    width: 12,
    height: 6,
    transform: "translate(66.51 63.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAGCAYAAAD37n+BAAAACXBIWXMAAAsSAAALEgHS3X78AAAAGklEQVQYlWNgIAEw8ztwMZGigYGBgWE4aAAAX7MAZwGD5u4AAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-6"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(69.51 44.41)",
    xlinkHref: "#image-3"
  })), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 37,
    transform: "translate(69.51 9.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAlCAYAAABh9JjQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAqklEQVQokcWQSw6CQBBEHzMt7vRK3v8k7owYE0EY3NDYVIa4tDbQKepHk8+XAjR8MQONhSNiTuzgr4QBZXnfbLF4qELH/SamWgkPL0qkRRExRSsn8/IcNHyMGb1kAoxxOcAQv3B5rFyiYlNZM1YXA15CtF5XB/ae0QmRgRxbOUYPelBBzSoByYC7EAfgbcBzz+paUbS1jCPQG3ATYl2uVrsZJ6Cr/US9t/gAw3Yz0jO5B4gAAAAASUVORK5CYII="
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-7"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(69.51 -.59)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-14"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(53.51 44.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAHklEQVQYlWNk5ndgZYCAv1CamQEXYOZ3YMIpOewBANoRAa3XYU2rAAAAAElFTkSuQmCC"
  })), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 37,
    transform: "translate(53.51 9.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAlCAYAAABh9JjQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAuklEQVQokcWQwQ6CMBBEH7BwkAR/yf//Em5GjQlFpB7o6rK0ZydpgE6ZeduqOV8iENlUpSdiNrHvNQX91bC4Frvyc6hiyThMno1aDVAUYHGnV6BW3HdaX1OA2Wyo2ZTKFzGnbJf4KNUsBnM1Rp3D/VIFths4dExA57o6pQquIwhwBxr2k3ea7QEWAR4ZKjQqS3UDWuBljFaAZylqBHp3oNeOkNZujiuFycdMxUmNIUWqBr3Eyf3hv3/6ABt2Pti3RbMkAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-11"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(53.51 -.59)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-16"
  }, /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 12,
    transform: "translate(38.51 44.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAMCAYAAABBV8wuAAAACXBIWXMAAAsSAAALEgHS3X78AAAAF0lEQVQYlWNk5ndgZUCAv1CamWEUoAMAg04BWXr2fkMAAAAASUVORK5CYII="
  })), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 37,
    transform: "translate(38.51 9.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAlCAYAAABh9JjQAAAACXBIWXMAAAsSAAALEgHS3X78AAAAtElEQVQokcWQyxKCMAxFDxLdMIO/5P9/iTtHHEdAKC5s9BZbx53Z5NHeR1LV+8PCMzxXACYD9MOGQvz1wYBA9I7sYquBx5Jb8EX100NwUwZMGUAwaWapawPGDGL+Kj7EjOiZb76mG92V3yyxG2SQ2B1EL9HoY7MTrZ3JYoNQ3gzoSgjn1ZtNBlzIhFJ9uDrHZgvcFXEtUR1j3cinRjUG3lfoDDiV9nCqokYrtK0esReA1mk8AIZiPMcCO5GPAAAAAElFTkSuQmCC"
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-3"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(38.51 -.59)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-10"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(23.51 44.41)",
    xlinkHref: "#image-3"
  })), /*#__PURE__*/React.createElement("image", {
    width: 6,
    height: 37,
    transform: "translate(23.51 9.41)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAlCAYAAABh9JjQAAAACXBIWXMAAAsSAAALEgHS3X78AAAArElEQVQokcWQOw4CMQxE3yaGBgmuxP1PQocArUSW/dDgxQyJKJkmcsaZT7p8OM5AxxsL0FkYIpZEA38lDJjD7H0Wk8W1j/Fd7jcx1YJE8xiCFF44pijlZH6dg5qP0aOIJ8CozYe44c9j3LkZVz1WFQPuQmw9rhYs7nEVIgM5pnKMbnSjgppUApIBFyE2wMOAviV1krsd0Nc8ClAMOAuxNleppsceuNY+UedPPAHHBDW5PkpWsgAAAABJRU5ErkJggg=="
  }), /*#__PURE__*/React.createElement("g", {
    className: "collect-tri-cls-5"
  }, /*#__PURE__*/React.createElement("use", {
    transform: "translate(23.51 -.59)",
    xlinkHref: "#image"
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "collect-tri-cls-1",
    points: "101.71 29.6 101.71 41.3 115.57 41.3"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "collect-tri-cls-1",
    cx: 108.26,
    cy: 69.32,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "collect-tri-cls-1",
    cx: 63.46,
    cy: 69.32,
    r: 8.8
  }), /*#__PURE__*/React.createElement("circle", {
    className: "collect-tri-cls-1",
    cx: 37.34,
    cy: 69.32,
    r: 8.8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollecteTriValorisation);
export default __webpack_public_path__ + "static/media/collecte-tri-valorisation.3072a136.svg";
export { ForwardRef as ReactComponent };